/**
 * Favourite Star
 * Contacts favorite button that writes favorite status
 * to a record when clicked
 */
import React from 'react';

import Icon from '@components/Icon/Icon';

import { StarImage } from './FavouriteStar.style';

const FavouriteStar: React.FC<{ id?: string | null }> = () => {
  const isFavourite: boolean = false;

  return (
    <StarImage>
      <Icon
        clickable
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        color={isFavourite ? 'warning.main' : 'grey.A400'}
        name="star"
        type="fas"
      />
    </StarImage>
  );
};

export default FavouriteStar;
